const Colors = {
    primary: '#4A90E2',
    secondary: '#50E3C2',
    textPrimary: '#333333',
    textSecondary: '#666666',
    background: '#F5F5F5',
    white: '#FFFFFF',
    black: '#000000',
    secondaryText: '#1F1F1F',
    borderGrey: '#D1D1D1',
    boxBackground: '#CACACA',
    titleTextColor: '#1F1F1F',
    subTitleColor: '#666',
    textInputBackground: '#F2F2F2',
    infoSubValue: '#737373',
    successInfoGreen: '#008A00',
    darkGrey: '#333333',
    buttonTextColor: '#FAFAFA',
    searchBackground: '#E8E8E8',
    radioButtonFilled: '#D9D9D9',
    searchCompanyBackground: '#F3F3F3',
    accountLock: '#111111',
    modalTitle: '#1A1A1A',
    applyText: '#B3B3B3',
    errorRedColor: '#DA291C',
    termsAndConditionsBlue: '#326AC2'
    // Add more colors as needed
};


export default Colors;